import { SpecialEvent } from "../Api"

export const TICKETMASTER_BASE_URL = 'https://www.ticketmaster.com'
export const TICKETMASTER_CAME_FROM = 'CAMEFROM=CFC_PREMIER_LACROSSE_LEAGUE_WEB_WEB_WEB'

export const HOMECOMING_BUY_LINKS: { [key: string]: string } = {
  albany: 'https://am.ticketmaster.com/pll/buy/quickbuy?id=Mjc5&camefrom=SCHEDULE',
  charlotte: 'https://am.ticketmaster.com/pll/buy/quickbuy?id=Mjgz&camefrom=SCHEDULE',
  philadelphia: 'https://am.ticketmaster.com/pll/buy/quickbuy?id=Mjg1&camefrom=SCHEDULE',
  baltimore: 'https://am.ticketmaster.com/pll/buy/quickbuy?id=Mjg3&camefrom=SCHEDULE',
  boston: 'https://am.ticketmaster.com/pll/buy/quickbuy?id=Mjkz&camefrom=SCHEDULE',
  'san-diego': 'https://am.ticketmaster.com/pll/buy/quickbuy?id=Mjg5&camefrom=SCHEDULE',
  denver: 'https://premierlacrosseleague.com/denver',
  'salt-lake-city': 'https://am.ticketmaster.com/pll/buy/quickbuy?id=Mjkx&camefrom=SCHEDULE',
}

export const HOMECOMING_LIVE_TIMES: { [key: string]: number } = {
  albany: 1738015693,
  charlotte: 1738015693,
  philadelphia: 1738015693,
  baltimore: 1738015693,
  minneapolis: 1738015693,
  boston: 1738015693,
  fairfield: 1738015693,
  'san-diego': 1738015693,
  denver: 1738015693,
  'salt-lake-city': 1738015693,
}

export const SPECIAL_TICKETING_EVENTS: SpecialEvent[] = [
  {
    week: 6,
    description: 'Maybelline WLL All-Star Game',
    hiddenDescription: 'Special Event - Announcement coming soon',
    startTime: 1751673600,
    slugname: 'maybelline-wll-all-star-game-sp-ev1',
    broadcaster: [],
    urlStreaming: '',
    link: '',
    showTime: 1741878136 //When to start showing description
  },
  // {
  //   week: 13,
  //   description: 'Stars & Stripes',
  //   hiddenDescription: 'Special Event - Announcement coming soon',
  //   startTime: 1756746000,
  //   slugname: 'stars-and-stripes-sp-ev1',
  //   broadcaster: [],
  //   urlStreaming: '',
  //   link: '',
  //   showTime: 1744815600 //When to start showing description
  // },
]
